"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const fragments_1 = require("../fragments");
const BlogHomeContentQuery = (0, graphql_tag_1.default) `
  query blogHomeContent($recommendationsLimit: Int = 3, $postsLimit: Int = 3) {
    blogHomeContent(
      recommendationsLimit: $recommendationsLimit
      recommendationPostsLimit: $postsLimit
    ) {
      recommendations {
        ...recommendations
      }
    }
  }
  ${fragments_1.BlogRecommendationsFragment}
`;
exports.default = BlogHomeContentQuery;
